<template>
  <el-dialog
    title="Ficha de Usuário"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="30%"
  > 
    <el-form size="small" label-position="top">
      <el-row>
        <el-form-item>
          <el-select v-model="opcao" value-key="data" style="width: 100%" default-first-option>
            <el-option
              v-for="item in opcoes"
              :key="item.data"
              :value="item.data"
              :label="item.label"
            />
          </el-select>
        </el-form-item>
      </el-row>
      <el-row v-if="opcaoIsEmail" style="margin-top: 10px">
        <el-form-item>
          <span slot="label">
            <strong>E-mail</strong>
          </span>
          <el-input v-model="email" />
        </el-form-item>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-row type="flex" justify="end">
        <el-button
          @click="concluirHandler"
          type="success"
          size="small"
          round
          class="btn-box-shadow"
        >
          {{ opcaoIsEmail ? 'Enviar' : 'Gerar' }}
        </el-button>

        <el-button
          @click="fechar"
          type="danger"
          size="small"
          round
          class="btn-box-shadow"
        >
          Fechar
        </el-button>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      opcao: "pdf",
      email: undefined,

      opcoes: [
        { label: "Gerar PDF", data: "pdf" },
        { label: "Enviar por e-mail", data: "email" }
      ],

      relatorio: {
        nome: undefined
      }
    };
  },
  computed: {
    ...mapState("usuariosStore", {
      usuario(state) { return state.usuarioSelecionado },
    }),

    opcaoIsEmail() {
      return this.opcao === "email";
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("usuariosStore", ["gerarFichaUsuario", "enviarFichaUsuarioPorEmail"]),

    concluirHandler() {
      switch(this.opcao) {
        case 'pdf':
          this.gerarFichaUsuarioHandler();
          break;
        case 'email':
          this.enviarFichaUsuarioPorEmailHandler();
      }

      this.fechar();
    },
    fechar() {
      this.reset();
      this.$emit("close");
    },
    reset() {
      this.opcao = "pdf";
      this.email = undefined;
    },
    gerarFichaUsuarioHandler() {
      this.relatorio.nome = "FICHA_DO_USUARIO";
      this.relatorio.usuario = this.usuario;

      this.showLoading();
      this.gerarFichaUsuario(this.relatorio)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              window.open(resultado.mensagem, "_blank");
              break;
            case "FALHA":
              this.$message.error("Não foi possível gerar a ficha do usuário");
          }
        })
        .catch(() => {
          this.hideLoading();

          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    enviarFichaUsuarioPorEmailHandler() {
      this.relatorio.nome = "FICHA_DO_USUARIO";
      this.relatorio.usuario = this.usuario;
      this.relatorio.emailParaEnvio = this.email;

      this.showLoading();
      this.enviarFichaUsuarioPorEmail(this.relatorio).then((resultado) => {
        this.hideLoading();

        switch (resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();

        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    }
  }
};
</script>